import { Injectable, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { Company } from '../models/company';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private titleService = inject(Title);
  private meta = inject(Meta);
  private canonicalLink?: HTMLLinkElement;

  /**
   * Updates the page title and meta tags based on company information.
   * This logic is decoupled from AppComponent to improve bootstrap performance.
   */
  updateMeta(company: Company): void {
    if (!company) return;

    const description = company.header?.description ?? 'O melhor Site de Apostas Esportivas. Saque instantâneo via Pix!';
    const keywords =
      company.header?.keywords ??
      'apostas, Apostas Esportivas, Ao-Vivo e Em tempo real, Transmissão ao-vivo, melhores cotações, odds garantidas, bônus 100%, futebol europeu, Premier League, UEFA, Liga dos Campeões, Jogos';

    this.updateCanonical(company.url);
    this.titleService.setTitle(company.friendly_name);

    const metaTags = [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:locale', content: 'pt_BR' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: company.friendly_name },
      { property: 'og:description', content: description },
      { property: 'og:url', content: company.url },
      { property: 'og:site_name', content: company.friendly_name },
      { property: 'og:image', content: company.logo },
      { property: 'og:image:secure_url', content: company.logo },
      { property: 'og:image:width', content: '1280' },
      { property: 'og:image:height', content: '720' },
      { property: 'og:image:alt', content: company.friendly_name },
      { property: 'og:image:type', content: 'image/png' },
    ];

    metaTags.forEach((tag) => this.meta.updateTag(tag));
  }

  private updateCanonical(url: string): void {
    if (!this.canonicalLink) {
      this.canonicalLink = document.querySelector<HTMLLinkElement>("link[rel='canonical']") ?? document.createElement('link');
      this.canonicalLink.rel = 'canonical';
      if (!this.canonicalLink.parentNode) {
        document.head.appendChild(this.canonicalLink);
      }
    }

    if (this.canonicalLink.href !== url) {
      this.canonicalLink.href = url;
    }
  }
}
